import React from "react";
import { Img } from "react-image";
import { Rate, Skeleton, Typography } from "antd";
import { useQueryClient, useMutation } from "@tanstack/react-query";
import TalentCandidate from "../../models/TalentCandidate.js";
import LoadingSpinner from "../../components/LoadingSpinner";
import UserImageCircle from "../../components/UserImageCircle";
import { useAuth } from "../../providers/AuthProvider.js";


const TalentReview = ({ review, onEdit, onUpdateTalent }) => {
    const { auth } = useAuth();
    const queryClient = useQueryClient();

    const isAuthReview = auth.id === review.reviewer.id;
    const isProjectReview = !!review.project || !!review.project_position;

    const deleteReviewMutation = useMutation(
        ['deleteReviewMutation'],
        () => TalentCandidate.deleteReviewToTalent(review.id),
        {
            onSuccess: async (res, props) => {
                console.log(res, 'dlete delete deleete REPONSE IN USEMUATION')

                await queryClient.setQueryData(['fetchTalentReviews', { talent_id: review.reviewable.id }], prevData => {
                    // return [...prevData, { ...DUMMY, notes, id: Math.floor(Math.random() * 100000) }]
                    return prevData.filter(prev => prev.id !== review.id)
                })
                if (res.reviewable && onUpdateTalent) {
                    let {
                        avg_review_rating, reviews_count, id
                    } = res.reviewable;

                    await onUpdateTalent({avg_review_rating, reviews_count, id})
                }
            }
        }
    )


    const handleDelete = async () => {
        const shouldDelete = await TB.alert('error', 'Are you sure?',
            'Are you sure you want to delete your review? This action cannot be undone',
            [
                { title: 'Yes, Delete' },
                { title: 'Cancel' }
            ]
        )

        if (shouldDelete) {
            deleteReviewMutation.mutate();
        }
    }

    return (
        <div
            className={TB.mapClass("talent-pool-review flex flex-col gap-7 pt-7 relative", {
                '-mr-4 -ml-4 pr-4 pl-4 bg-gray-100': isAuthReview && !isProjectReview,
            })}
        >

            {(isAuthReview && !isProjectReview) && (
                <p className="absolute -top-3 text-lg">My Review</p>
            )}

            <div>
                <div className="flex justify-between items-center">
                    <div>
                        <p className="font-semibold">{review.title}</p>
                    </div>

                    {review.rating && (
                        <div className="flex items-center gap-3">
                            <Rate disabled allowHalf value={review.rating} />
                            <p className="text-primary font-semibold">{review.rating} Stars</p>
                        </div>
                    )}
                </div>


                <Typography.Paragraph className="py-2 text-xs whitespace-pre-line" ellipsis={{ rows: 3, expandable: true, symbol: 'Read More' }}>
                    {review.notes || 'Notes not available'}
                </Typography.Paragraph>

                <div className="flex justify-between gap-4 pt-2 pb-3">
                    <div className="w1/4 p- border-b2">

                        {isAuthReview && !isProjectReview ? (
                            <div className="flex gap-4">
                                <button
                                    type="button"
                                    className="btn btn-link"
                                    // disabled={isUpdating}
                                    onClick={() => {
                                        onEdit({
                                            rating: review.rating,
                                            notes: review.notes,
                                            title: review.title,
                                        })
                                    }}
                                >
                                    Edit Review
                                </button>

                                <button
                                    type="button"
                                    className="btn btn-link text-red-500"
                                    // disabled={isUpdating}
                                    onClick={handleDelete}
                                >
                                    Delete
                                </button>
                            </div>
                        ) : (
                            <div className="bg-red-10 p- flex flex-col h-full justify-center">
                                <p className="text-xs mb-1">{review.project_position?.title}</p>
                                <p className="text-xs text-wripplePrimaryLightBlue">{review.project?.name}</p>
                            </div>
                        )}

                    </div>

                    <div className="flex items-center gap-4 pb5">
                        <div className="text-right">
                            <p className="text-xs mb-1">{review.reviewer.first_name} {review.reviewer.last_name.substr(0, 1)}.</p>
                            <p className="text-xs text-wripplePrimaryLightBlue">{review.client?.name}</p>
                        </div>

                        <div>
                            <Img
                                loader={<div className="loading-user-image"><LoadingSpinner size="lg" /></div>}
                                src={review.reviewer.image_path}
                                unloader={<UserImageCircle user={review.reviewer} hideTooltip={true} size={116} className="img-fluid img-grayscale h-14" />}
                                className="img-fluid img-grayscale h-14 rounded-full"
                            />
                        </div>
                    </div>
                </div>
                <div className="border-b-2 w-1/4"></div>
            </div>
        </div>
    )
}

export default TalentReview;

export const TalentReviewSkeleton = () => {
    return (
        <div>
            <div className="flex justify-between items-center pb-3">
                <div className="w-3/4">
                    <Skeleton active title={false} paragraph={{ rows: 1, width: '50%' }} />
                </div>

                <div className="flex items-center gap-3 w-1/4">
                    <Skeleton active title={false} paragraph={{ rows: 1, width: '100%' }} />
                </div>
            </div>

            <div className="py-2">
                <Skeleton active title={false} paragraph={{ rows: 3, width: ['100%', '100%', '50%'] }} />
            </div>

            <div className="flex justify-between gap-4">
                <div className="w-1/4 p-2 border-b-2" />

                <div className="flex items-center gap-4 review-avatar-skeleton">
                    <div className="text-right min-w-[100px]">
                        <Skeleton active title={false} paragraph={{ rows: 2, width: ['50%', '100%'] }} />
                    </div>

                    <div>
                        <Skeleton.Avatar active size="large" />
                    </div>
                </div>
            </div>
        </div>
    )
}